import { Component, effect, input, InputSignal, OnInit, ViewChild } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { AFSSelectInputComponent } from "@afs-ng/inputs";
import { FormsModule } from '@angular/forms';
import { AssignEmployeesComponent } from "../assign-employees/assign-employees.component";

@Component({
    selector: 'support-assign',
    imports: [FormsModule, IonicModule, AFSSelectInputComponent, AssignEmployeesComponent],
    templateUrl: './support-assign.component.html',
    styleUrls: ['./support-assign.component.scss', '../../assign.scss'],
    standalone: true
})
export class SupportAssignComponent implements OnInit {

  @ViewChild("assignEmployees") assignEmployees: AssignEmployeesComponent
  
  public ticketTypes: any[] = [] 

  public inputTicketType: InputSignal<number> = input<number>(null)
  public selectedTicketType: number = null

  public selectedEmployeeIds: number[] = []


  public get isValid(){
    return this.selectedTicketType !== null && this.selectedEmployeeIds.length > 0
  }

  constructor(
    private ticketEditSrv: TicketEditService,
  ){
    effect(() => this.selectedTicketType = this.inputTicketType())
  }

  ngOnInit(): void {
    this.ticketTypes = this.ticketEditSrv.ticketArts.map(art => ({value: art.id, name: art.description}))
  }

  public clear(){
    this.selectedEmployeeIds = []
    this.assignEmployees.clear()
  }

  


}
